
















































import Vue from 'vue'
import { faSearch } from '@fortawesome/free-solid-svg-icons'
import { mapDeps } from '~/plugins/dependency-container/utils'
import AccessTogglesService from '~/services/user/AccessTogglesService'
import {
  AccessToggle,
  AccessToggleIdentifier
} from '~/models/user/access-toggles'
import CUserAccessTogglesModalItem from '~/components/shared/configurable/access-toggle/CUserAccessTogglesModalItem.vue'
import { PropType } from '@nuxtjs/composition-api'

export default Vue.extend({
  components: {
    CUserAccessTogglesModalItem
  },
  model: {
    prop: 'show',
    event: 'input'
  },
  props: {
    show: {
      type: Boolean,
      required: true
    },
    identifier: {
      type: [String, Number] as PropType<AccessToggleIdentifier>,
      required: true
    },
    userDisplayName: {
      type: String,
      default: null
    }
  },
  data(): { loading: boolean; accessToggles: AccessToggle[]; query: string } {
    return {
      loading: true,
      accessToggles: [],
      query: ''
    }
  },
  computed: {
    ...mapDeps({
      accessTogglesService: AccessTogglesService
    }),
    displayedAccessToggles() {
      const { query } = this
      if (query) {
        return this.accessToggles.filter(a =>
          a.disallowReasonDescription
            .toLowerCase()
            .includes(query.toLowerCase())
        )
      }
      return this.accessToggles
    },
    visible: {
      get() {
        return this.show
      },
      set(value: boolean) {
        this.$emit('input', value)
        this.$emit('change', value)
      }
    },
    icons: () => ({
      search: faSearch
    })
  },
  async mounted() {
    this.loading = true
    await this.loadAccessToggles()
    this.loading = false
  },
  beforeDestroy() {
    this.$emit('close')
  },
  methods: {
    async loadAccessToggles() {
      const { accessTogglesService, identifier } = this
      try {
        const { accessToggles } = await accessTogglesService.getAccessToggles(
          identifier
        )
        this.accessToggles = accessToggles
      } catch (error) {
        this.$logger.captureError(error)
      }
    }
  }
})
